export default __webpack_public_path__ + "btn-del2.png?53b2bd19e6add7d01e918cd635890077";